import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AmountCell.module.scss';

const cx = classnames.bind(styles);

export type AmountCellProps = {
  totalAmount: string;
  foreignCurrencyAmount: string | null;
};

export const AmountCell: FC<AmountCellProps> = memo(
  ({ totalAmount, foreignCurrencyAmount }) => {
    return (
      <>
        <div>{totalAmount}</div>
        {foreignCurrencyAmount && (
          <div className={cx('foreignCurrencyAmount')}>
            {foreignCurrencyAmount}
          </div>
        )}
      </>
    );
  }
);
AmountCell.displayName = 'AmountCell';
